var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
import React from 'react';

/**
 * @ignore
 */
const RDStationLogo = _ref => {
  let {
    title,
    titleId
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    width: "375",
    height: "69",
    viewBox: "0 0 375 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M345.483 18.4478H353.767L368.455 42.475H368.993L368.455 38.2164V18.4478H374.59V50.499H366.306L351.618 26.4718H351.081L351.618 30.7303V50.499H345.483V18.4478Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M321.75 17.4167C332.139 17.4167 339.617 24.9028 339.617 34.4958C339.617 44.0888 332.139 51.5749 321.75 51.5749C311.361 51.5749 303.883 44.0888 303.883 34.4958C303.883 24.9028 311.316 17.4167 321.75 17.4167ZM321.75 45.7025C328.422 45.7025 333.213 40.9061 333.213 34.4958C333.213 28.0856 328.422 23.2891 321.75 23.2891C315.078 23.2891 310.286 28.0856 310.286 34.4958C310.286 40.9061 315.078 45.7025 321.75 45.7025Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M291.837 18.4478H297.971V50.499H291.837V18.4478Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M258.475 18.4478H287.583V24.3201H276.119V50.499H269.984V24.3201H258.475V18.4478Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M235.772 18.4478H250.281L259.282 50.499H253.147L250.997 42.7439H234.966L232.817 50.499H226.682L235.772 18.4478ZM249.43 36.9164L245.982 24.3649H240.116L236.668 36.9164H249.43Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M198.47 18.4478H227.577V24.3201H216.114V50.499H209.979V24.3201H198.47V18.4478Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M174.692 40.906C174.961 41.8473 175.453 42.7439 176.125 43.4611C177.334 44.7611 179.349 45.9714 182.976 45.9714C188.305 45.9714 190.454 43.8197 190.454 41.7128C190.454 38.306 185.26 37.4991 180.066 36.3784C174.826 35.2578 169.677 33.0612 169.677 27.0096C169.677 21.9442 174.199 17.3718 182.752 17.3718C188.753 17.3718 192.201 19.7925 194.171 22.1683C195.336 23.6028 196.142 25.2165 196.634 26.9648H190.231C189.962 26.2924 189.559 25.5752 188.887 24.9924C187.812 23.9614 185.932 22.9752 182.752 22.9752C177.916 22.9752 176.08 24.589 176.08 26.6958C176.08 29.1165 179.036 30.2372 182.663 30.9544C188.798 32.1647 196.903 33.6888 196.903 41.3542C196.903 46.6886 192.156 51.4851 183.021 51.4851C176.259 51.4851 172.453 48.8851 170.438 46.1507C169.274 44.5818 168.467 42.7887 168.109 40.8163H174.692V40.906Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M156.466 34.4958C156.466 24.5891 148.451 17.4167 137.345 17.4167H123.061V51.6197H137.345C148.406 51.5749 156.466 44.4025 156.466 34.4958ZM133.226 42.9233V26.0683H137.077C142.406 26.0683 145.764 29.2959 145.764 34.4958C145.764 39.6957 142.45 42.9233 137.077 42.9233H133.226Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M111.821 39.5164C112.895 39.0233 113.881 38.2613 114.776 37.3199C116.791 35.2579 117.776 32.7027 117.776 29.6993C117.776 22.4374 112.089 17.4167 103.984 17.4167H85.6244V51.6197H95.7895V41.7578H102.014L107.567 51.6197H117.821L111.194 39.8302L111.821 39.5164ZM102.999 33.5544H95.8343V25.7994H102.999C105.507 25.7994 107.388 27.458 107.388 29.6545C107.388 31.8958 105.507 33.5544 102.999 33.5544Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2393 49.9411L68.5005 62.6185V51.2516L34.2393 38.5742L0.00488281 51.2516V62.6185L34.2393 49.9411Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2393 49.9414L0.00488281 62.6188L12.7121 68.7435L34.2393 60.7734L55.7933 68.7435L68.5005 62.6188L34.2393 49.9414Z",
    fill: "#19C1CE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2393 19.0501L0.00488281 6.37256V17.7395L34.2393 30.417L68.5005 17.7395V6.37256L34.2393 19.0501Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2393 19.0501L68.5005 6.37253L55.7933 0.247803L34.2393 8.21808L12.7121 0.247803L0.00488281 6.37253L34.2393 19.0501Z",
    fill: "#19C1CE"
  })));
};
RDStationLogo.displayName = 'RDStationLogo';
RDStationLogo.caption = 'RD Station';
export default RDStationLogo;